import React, { useEffect, useRef } from 'react';

// Mobile Only: 4 Videos (Promo Removed)
const VIDEOS = [
  {
    id: 2,
    url: "https://res.cloudinary.com/digw3ykex/video/upload/q_auto,vc_auto/v1/Living_media_vacuum_dhyixh.mp4"
  },
  {
    id: 3,
    url: "https://res.cloudinary.com/digw3ykex/video/upload/q_auto,vc_auto/v1/living_media_-_dancing_zl9cru.mp4"
  },
  {
    id: 4,
    url: "https://res.cloudinary.com/digw3ykex/video/upload/q_auto,vc_auto/v1/LivingMedia_BTS_fnejyr.mp4"
  },
  {
    id: 5,
    url: "https://res.cloudinary.com/digw3ykex/video/upload/q_auto,vc_auto/v1/Living_Media_Coffee_vc2hmh.mp4"
  }
];

const MobileHeroAnimation = () => {
  // Refs to control video playback programmatically
  const videoRefs = useRef([]);

  useEffect(() => {
    // Global Media Unlock Handler
    // iOS/Chrome require a user interaction (tap/scroll) to allow video playback
    const unlockVideos = () => {
      videoRefs.current.forEach((video) => {
        if (video && video.paused) {
          // Attempt to play. We catch errors to prevent console noise if the browser 
          // still decides to block it (though muted should pass).
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch((error) => {
              // Auto-play was prevented
              console.debug("Autoplay unlock waiting for user interaction", error);
            });
          }
        }
      });

      // Once triggered, we remove the listeners to avoid performance overhead
      // We assume the session is now "unlocked" for media
      ['touchstart', 'click', 'scroll'].forEach((event) => {
        window.removeEventListener(event, unlockVideos);
      });
    };

    // Attach listeners to the window to catch ANY interaction
    ['touchstart', 'click', 'scroll'].forEach((event) => {
      window.addEventListener(event, unlockVideos, { passive: true });
    });

    return () => {
      // Cleanup listeners on unmount
      ['touchstart', 'click', 'scroll'].forEach((event) => {
        window.removeEventListener(event, unlockVideos);
      });
    };
  }, []);

  return (
    <div 
      className="md:hidden relative w-[calc(100%+3rem)] -ml-6 h-[460px] my-6 overflow-hidden select-none z-0"
      aria-hidden="true"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-56 h-56 bg-[#BEF264]/10 rounded-full blur-[80px] pointer-events-none animate-pulse" />

      {VIDEOS.map((item, index) => {
        // Animation timing: 4 items over 16s = 4s stagger
        const delay = (index * -4) + 's';
        
        // Cloudinary Poster Generation
        const posterUrl = `https://res.cloudinary.com/digw3ykex/video/upload/so_0,f_jpg,q_auto/v1/${item.url.split('/').pop().replace('.mp4', '')}.jpg`;
        
        return (
          <div
            key={item.id}
            className="mobile-hero-item absolute w-[180px] aspect-[9/19.5] animate-mobile-rotate"
            style={{ 
              animationDelay: delay,
              top: '50%',
              left: '50%',
              marginTop: '-195px',
              willChange: 'transform, opacity',
              contentVisibility: 'auto',
              containIntrinsicSize: '180px 390px'
            }}
          >
            <div className="relative w-full h-full bg-[#0a0a0a] rounded-[1.5rem] shadow-2xl ring-1 ring-white/20 overflow-hidden">
              <div 
                className="absolute inset-[2px] rounded-[1.35rem] overflow-hidden bg-black"
                style={{ transform: 'translateZ(0)' }}
              >
                <div className="w-full h-full relative pointer-events-none bg-black overflow-hidden">
                  <div className="absolute inset-0 z-50 bg-transparent" />
                  
                  {/* Full-size Wrapper for Video */}
                  <div className="absolute top-0 left-0 w-full h-full overflow-hidden bg-black">
                    {/* Native HTML5 Video - Starts Paused */}
                    <video
                      ref={(el) => (videoRefs.current[index] = el)}
                      src={item.url}
                      className="absolute inset-0 w-full h-full object-cover"
                      style={{ border: 'none' }}
                      // CRITICAL: autoplay is FALSE. We trigger via JS on interaction.
                      autoPlay={false}
                      loop={true}
                      muted={true}
                      playsInline={true}
                      poster={posterUrl}
                      preload="auto"
                    />
                  </div>
                </div>

                {/* Dynamic Island */}
                <div 
                  className="absolute top-2.5 left-1/2 w-[30%] h-4 bg-black rounded-full z-[100] flex items-center justify-center gap-1 shadow-sm"
                  style={{ transform: 'translate3d(-50%, 0, 2px)' }}
                >
                  <div className="w-1 h-1 rounded-full bg-[#1a1a1a]" />
                  <div className="w-1 h-1 rounded-full bg-[#111]" />
                </div>

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/60 z-30 pointer-events-none" />

                {/* Home Indicator */}
                <div className="absolute bottom-1.5 left-1/2 -translate-x-1/2 w-[35%] h-0.5 bg-white/60 rounded-full z-30" />

                {/* Reflection */}
                <div className="absolute inset-0 bg-gradient-to-tr from-white/10 via-transparent to-white/5 pointer-events-none mix-blend-overlay z-40" />
              </div>

              {/* Frame */}
              <div className="absolute inset-0 rounded-[1.5rem] border-[2px] border-[#5C6B46] pointer-events-none" />
              
              {/* Highlight */}
              <div className="absolute top-0 right-0 w-full h-full rounded-[1.5rem] border-t border-r border-white/10 opacity-50 pointer-events-none" />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MobileHeroAnimation;